import { z } from "zod";
import { gql } from "graphql-request";

export const ImageSchema = z
  .object({
    title: z.string().nullable(),
    url: z.string().url().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
  })
  .default({
    title: null,
    url: null,
    width: null,
    height: null,
  });

export const Image = ImageSchema;
export type Image = z.infer<typeof ImageSchema>;

export const ImageFragment = gql`
  fragment ImageFragment on Asset {
    title
    width
    height
    url
  }
`;
